
import './App.css';
import Header from './components/header.js';
import MainBanner from './components/mainbanner';

function App() {
  return (
    <div className="container">
      <Header/>
      <MainBanner/>
    </div>

  )
}

export default App;
